import {
  fetchWithErrorHandling,
  throwErrorsIfBadResponse,
} from '@github-ui/pull-request-page-data-tooling/fetch-error-handling'
import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {useMutation, useQueryClient} from '@github-ui/react-query'
import {threadPreviewsQueryKey} from '../page-data/payloads/thread-previews'
import {useMarkersActions} from '../stores/selectors'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import type {FilesRoutePayload} from '../page-data/payloads/files'
import type {FileKey, LineKey} from '@github-ui/diff-lines/types'

export function useUnresolveThreadMutation(filePath: string, lineMarkersKey: LineKey | FileKey) {
  const {
    pullRequest: {pathName: basePath},
  } = useRoutePayload<FilesRoutePayload>()
  const apiUrl = `${basePath}/page_data/${PageData.unresolveThread}`
  const queryClient = useQueryClient()
  const {updateThread} = useMarkersActions()

  return useMutation({
    mutationFn: async ({threadId}: {threadId: string}) => {
      const response = await fetchWithErrorHandling(apiUrl, {
        method: 'POST',
        body: {
          threadId,
        },
      })

      throwErrorsIfBadResponse(response)
    },
    onSuccess: (_data, variables) => {
      updateThread(Number(variables.threadId), filePath, lineMarkersKey, oldThread => {
        if (oldThread) {
          return {...oldThread, isResolved: false, resolvedBy: undefined}
        }
      })

      // invalidate pullRequestFilesToolbar queries
      return queryClient.invalidateQueries({
        queryKey: threadPreviewsQueryKey(basePath),
      })
    },
  })
}
